import { Box, Button, Layer, Text } from 'grommet';
import { ReactNode } from 'react';

export interface IConfirmModalProps {
  /** The question, e.g. "Archive Spring Campaign?" */
  title?: string;
  content: ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm: () => void;
  onCancel?: () => void;
  /** Deletes or cancels something: the confirm button is red */
  danger?: boolean;
}

export const ConfirmModal = ({
  title,
  content,
  confirmLabel,
  cancelLabel,
  onConfirm,
  onCancel,
  danger,
}: IConfirmModalProps) => {
  return (
    <Layer onEsc={onCancel} onClickOutside={onCancel} position="center" margin="large" modal>
      <Box pad="medium" gap="medium" width={{ max: 'medium' }}>
        {title && (
          <Text size="17px" weight={600} color="text-heading">
            {title}
          </Text>
        )}
        {typeof content === 'string' ? <Text size={title ? 'small' : undefined}>{content}</Text> : content}
        {/* Cancel first, the action last and filled, as in Delete's confirmation */}
        <Box direction="row" align="center" justify="end" gap="small">
          <Button label={cancelLabel || 'Cancel'} onClick={onCancel} />
          <Button
            label={confirmLabel || 'Confirm'}
            onClick={onConfirm}
            primary
            color={danger ? 'text-danger' : undefined}
          />
        </Box>
      </Box>
    </Layer>
  );
};
